


















import { Component, Vue } from 'vue-property-decorator';

import DetailsCar from '@/components/car/DetailsCar.vue';
import DiscountCode from '@/components/car/DiscountCode.vue';
import DetailsPayment from '@/components/car/DetailsPayment.vue';

import mainStore from '@/store/main-store/MainStore';

import { Products } from '@/models/Products';

@Component({
    name: 'Car',
    components: {
        DetailsCar,
        DiscountCode,
        DetailsPayment,
    },
})
export default class Car extends Vue {
    private mainStore = mainStore.context(this.$store);

    private get carProducts(): Products[] {
        return this.mainStore.state.car;
    }

    private get totalPriceCar(): number {
        return this.mainStore.getters.totalPriceCar;
    }

    private get totalProductsCar(): number {
        return this.mainStore.getters.totalProductsCar;
    }

    private removeProduct(product: Products): void {
        this.mainStore.actions.removeProductFromCar(product);
    }

    private applyCode(code: string): void {
        this.mainStore.actions.setDiscount(code);
    }
}
